import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class IgPatternValidator {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
  static compareWith(compareWith: string, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      const e = control.root.get(compareWith);
      if (e && control.value !== e.value) {
        return error;
      } else {
        return null;
      }
    };
  }
}
